module.exports = __webpack_public_path__ + "static/media/seclogoanimado.7f9ca371.gif";